module.exports = "/_next/static/images/oscola-modal-1b2fc707cc3745809ddb4330be3dca85.png";